import { Accordion } from '@components/atoms/Accordion'
import EmptyState from '@components/molecules/EmptyState'
import { scopedTranslation } from '@frontend/utils/I18n'
import type { CompletedCycleType } from '@frontend/graphql/queries/callingSession'
import { CycleAccordionItem } from './CycleAccordionItem'

const t = scopedTranslation('components.impact_dashboard')

type CallingJourneyPanelProps = {
  completedCycles: CompletedCycleType[]
}

export function CallingJourneyPanel({ completedCycles }: CallingJourneyPanelProps) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <span className="tw:text-sm tw:font-bold tw:uppercase tw:text-gray-blue-500">
        {t('your_journey_flag')}
      </span>

      {completedCycles.length === 0 ? (
        <EmptyState
          headline={t('journey.empty_headline')}
          subtext={t('journey.empty_subtext')}
          iconType="refresh-cw-04"
        />
      ) : (
        <Accordion type="multiple" defaultValue={[]}>
          {completedCycles.map((cycle) => (
            <CycleAccordionItem key={cycle.id} cycle={cycle} />
          ))}
        </Accordion>
      )}
    </div>
  )
}
